<div class="modal-body">
    <div class="alert alert-success border-success text-body" role="alert">
        <h6><strong translate="Settings.AccountSecuritySection.Dialog.SecurityKeyEnabled"></strong></h6>
        <span class="lh-base" translate="Settings.AccountSecuritySection.Dialog.InformationSecurityKeyComplete"></span>
    </div>
</div>

<div class="modal-footer border-top-active d-table w-100">
    <span class="float-end"><button type="button" class="btn btn-sm btn-primary" (click)="close()" translate="Button.Close"></button></span>
</div>